import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useParams } from 'react-router-dom';

import { getPageNameByPath } from './ProjectRouteToolbarUtils';
import ProjectRouteToolbar from './ProjectRouteToolbar';

export function ProjectRouteToolbarContainer({ conditionsIsShown, setConditionsIsShown, onExport, routeType }) {
  const { projectId, routeId } = useParams();
  const location = useLocation();
  const [pageName, setPageName] = useState(getPageNameByPath(location.pathname));

  useEffect(() => {
    setPageName(getPageNameByPath(location.pathname));
  }, [location]);

  return (
    <ProjectRouteToolbar
      projectId={projectId}
      routeId={routeId}
      pageName={pageName}
      conditionsIsShown={conditionsIsShown}
      setConditionsIsShown={setConditionsIsShown}
      onExport={onExport}
      routeType={routeType}
    />
  );
}

ProjectRouteToolbarContainer.defaultProps = {
  onExport: () => null,
};

ProjectRouteToolbarContainer.propTypes = {
  onExport: PropTypes.func,
  routeType: PropTypes.string,
};

export default ProjectRouteToolbarContainer;
